module.exports = __webpack_public_path__ + "static/media/mdi_mail_outline.ec8f04ed.svg";